import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { OPTIMIZELY_FEATURE_FLAGS_KEYS, PARTNERS_SCHEDULE_FILTERS_V2 } from 'components/Optimizely/Optimizely.features';
import { isFeatureEnabledForUser } from 'components/Optimizely/Optimizely.sdk';

import { reportError } from 'helpers/error-logging';

import { selectUserId } from 'selectors/general';

export const FLAG_RESOLUTION_TIMEOUT_MS = 2000;

const VENUE_ATTRIBUTE = 'active_venue_id';

export function useIsScheduleFiltersV2Enabled(venueId) {
  const userId = useSelector(selectUserId);
  const [isScheduleFiltersV2Enabled, setIsScheduleFiltersV2Enabled] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const timeoutId = setTimeout(() => {
      if (isMounted) setIsScheduleFiltersV2Enabled(current => (current === null ? false : current));
    }, FLAG_RESOLUTION_TIMEOUT_MS);

    async function loadScheduleFiltersV2Flag() {
      try {
        const enabled = await isFeatureEnabledForUser(
          OPTIMIZELY_FEATURE_FLAGS_KEYS[PARTNERS_SCHEDULE_FILTERS_V2],
          userId,
          { [VENUE_ATTRIBUTE]: venueId }
        );

        if (isMounted) setIsScheduleFiltersV2Enabled(enabled);
      } catch (error) {
        reportError('Failed to resolve schedule-filters-v2 flag', { error, userId, venueId });
        if (isMounted) setIsScheduleFiltersV2Enabled(false);
      }
    }

    if (userId && venueId) {
      loadScheduleFiltersV2Flag();
    } else {
      setIsScheduleFiltersV2Enabled(false);
    }

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [userId, venueId]);

  return isScheduleFiltersV2Enabled;
}
